import React, { Component } from 'react';
import '../static/css/bootstrap.min.css'
import '../index.css'
import sponser1 from '../resources/p13_img1.png'
import sponser2 from '../resources/p13_img2.png'


class Section13 extends Component {
  render() {
    return (
      <section id="page_13">
        <div className="container">
          <div className="row">
            <div className="col-sm-offset-2 col-sm-8 text-center">
              <div className="title">
                メディア
              </div>
              <img src={sponser1} className="img-responsive sponser" alt='sponser1' />
            </div>

            <div className="col-sm-offset-2 col-sm-8 text-center">
              <div className="title">
                パートナー
              </div>
              <img src={sponser2} className="img-responsive sponser" alt='sponser2'/>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Section13;



// WEBPACK FOOTER //
// ./src/sections/Section13.js